/*
* Handles the AJAX on rollup pages
 */
jQuery(document).ready( function($) {
	if ( 0 < $( 'body.page-template-page-rollup-news-events' ).length ) {
		// Set default post roll-up parameters on page refresh
		let pageNumber = 1;
		let postType = "";
		let order = "";

		// Set the post type dependent on landing page id
		if ( get_id_from_body_tag() === 36 ) {
			postType = 'events';
		}
		if ( get_id_from_body_tag() === 35 ) {
			postType = 'news';
		}

		// console.log('Post type: ' + postType);
		console.log( 'POST ID:' + get_id_from_body_tag() );

		if ( postType === "events" ) {
			order = "ASC";
		} else {
			order = "DESC";
		}
		let orderBy = "date";
		let pastEvents = "false";
		let activeSorting = "latest";
		// Create the preloader
		const preloaderClassName = 'preloader__rollup_news_events';
		const preloaderAnimation = '/wp-content/themes/rsa-main/img/preloader_rsa.svg';
		const preloader = '<div class="' + preloaderClassName + '"><img src="' + preloaderAnimation + '" alt="Preloader"></div>';

		// Get the current id from the class within the body tag
		function get_id_from_body_tag() {
			let id = 0;
			const classes = $( 'body' ).attr( 'class' );
			const classesArray = classes.split( ' ' );
			const classPattern = 'page-id-';

			for ( let theClass of classesArray ) {
				if ( theClass.includes( classPattern ) ) {
					id = theClass.replace( classPattern, '' );
				}
			}
			return parseInt( id );
		}

		// Hide the preloader
		function hide_preloader() {
			setTimeout( () => {
				$( '.' + preloaderClassName ).fadeOut(
					400,
					function() {
						$( this ).remove();
					}
				);
			}, 500 )
		}
		// Show the preloader
		function show_preloader() {
			const preloaderClass = '.' + preloaderClassName;
			if ( 0 === $( preloaderClass ).length ) {
				$( preloader ).prependTo( 'body' );
				$( preloaderClass ).fadeIn();
			}
		}

		// Pull the main site posts in via AJAX
		function loadPostsMain(pageNumber, postType, order, orderBy, pastEvents, activeSorting = null) {
			$.ajax({
				type: "GET",
				data: {
					numPosts: -1,
					pageNumber: pageNumber,
					postType: postType,
					order: order,
					orderBy: orderBy,
					pastEvents: pastEvents,
					sortOptions: true,
					nonce: ajaxPostsRollup.nonce
				},
				dataType: "html",
				url: ajaxPostsRollup.url_main,
				beforeSend: function () {
					show_preloader();
				},
				success: function (html) {
					hide_preloader();
					// Render the posts into a div
					$('#fwpostrollup-main').hide().html(html).fadeIn();
					// Set the active sorting option to display on page
					if (activeSorting != null) {
						// Add active state to selected sorting option
						$('.fwpostrollup__sortoptions a[data-option="' + activeSorting + '"]').addClass('active');
					}
					// Set the post ordering from sort option
					$('.fwpostrollup__sortoptions a').on("click", function (event) {
						switch ($(this).attr('data-option')) {
							case 'latest':
								if (postType === "events") {
									order = "ASC";
								} else {
									order = "DESC";
								}
								orderBy = "date";
								pastEvents = "false";
								break;
							
							case 'oldest':
								order = "ASC";
								orderBy = "date";
								pastEvents = "";
								break;
							
							case 'az':
								order = "ASC";
								orderBy = "title";
								pastEvents = "";
								break;
							
							case 'za':
								order = "DESC";
								orderBy = "title";
								pastEvents = "";
								break;
							
							case 'pe':
								order = "DESC";
								orderBy = "date";
								pastEvents = "true";
								break;
						}
						
						// Reset the current page number to 1
						pageNumber = 1;
						
						// Register this sorting option as active
						activeSorting = $(this).attr('data-option');
						
						// Re-run this function to re-render the SORTED posts back into the html
						loadPostsMain(pageNumber, postType, order, orderBy, pastEvents, activeSorting);
					});
					
					// Re-render the posts back into the html on NEW page selection
					$('.pagination__item--trigger').on("click", function (event) {
						pageNumber = $(this).html();
						loadPostsMain(pageNumber, postType, order, orderBy, pastEvents, activeSorting);
					});
					
					// Re-render the posts back into the html on NEXT page selection
					$('.pagination__item--next').on("click", function (event) {
						pageNumber++;
						loadPostsMain(pageNumber, postType, order, orderBy, pastEvents, activeSorting);
					});
				},
				
				// If PHP error in AJAX targeted file...
				error: function (jqXHR, textStatus, errorThrown) {
					console.log('AJAX error');
					alert(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}
			});
		}

		// Pull the Europe site posts in via AJAX
		function loadPostsEurope(pageNumber, postType, order, orderBy, pastEvents, activeSorting = null) {
			$.ajax({
				type: "GET",
				data: {
					numPosts: -1,
					postType: postType,
					order: order,
					orderBy: orderBy,
					pastEvents: pastEvents,
					sortOptions: false,
					nonce: ajaxPostsRollup.nonce
				},
				dataType: "html",
				url: ajaxPostsRollup.url_europe,
				beforeSend: function () {
					show_preloader();
				},
				success: function (html) {
					hide_preloader();
					// Render the posts into a div
					$('#fwpostrollup-europe').hide().html(html).fadeIn();
				},
				
				// If PHP error in AJAX targeted file...
				error: function (jqXHR, textStatus, errorThrown) {
					console.log('AJAX error');
					alert(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}
			});
		}

		// Reload posts on page refresh
		loadPostsMain( pageNumber, postType, order, orderBy, pastEvents, activeSorting );
		loadPostsEurope( pageNumber, postType, order, orderBy, pastEvents );
	}
});